"use client";

import { capture } from "@/lib/analytics/events";

/**
 * The "Apply on official site" link on a job page (CM-2). Identical markup to
 * the plain <a> it replaces — it just fires the `apply_click` conversion event
 * before the browser opens the official application in a new tab. The
 * navigation is the anchor's own default (target=_blank), so the event firing
 * never blocks or delays the apply.
 *
 * `apply_click` is the single strongest jobseeker-intent signal on the site,
 * so the click also broadcasts `changemaker:apply_click`. PostApplyAlert
 * listens for it and makes the ask once the visitor comes BACK to this tab.
 *
 * That slot used to hold a micro-survey ("was anything about this listing
 * unclear?"). It was given the one-tap quickOption treatment and a
 * reveal-on-return fix, and still answered 4 times against 561 shown over 30
 * days. The moment is too valuable for a question nobody answers, so T-247
 * gave it to the email ask instead — the same trigger, a better use of it.
 */
export function ApplyLink({
  href,
  jobId,
  orgKey,
  placement,
  className,
  children,
}: {
  href: string;
  jobId: number;
  orgKey: string;
  placement: "sidebar" | "mobile";
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener nofollow"
      onClick={() => {
        capture("apply_click", { job_id: jobId, org_key: orgKey, placement });
        window.dispatchEvent(new CustomEvent("changemaker:apply_click"));
      }}
      className={className}
    >
      {children}
    </a>
  );
}
